var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailContact(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 78,
    height: 78,
    rx: 39,
    fill: "#467CD2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 78,
    height: 78,
    rx: 39,
    stroke: "#C5DBFF",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1663 55.8337C24.1122 55.8337 23.2101 55.4586 22.46 54.7086C21.71 53.9585 21.3343 53.0558 21.333 52.0003V29.0003C21.333 27.9462 21.7087 27.044 22.46 26.294C23.2113 25.5439 24.1135 25.1683 25.1663 25.167H55.833C56.8872 25.167 57.7899 25.5427 58.5413 26.294C59.2926 27.0453 59.6676 27.9474 59.6663 29.0003V52.0003C59.6663 53.0545 59.2913 53.9572 58.5413 54.7086C57.7912 55.4599 56.8885 55.8349 55.833 55.8337H25.1663ZM40.4997 42.417L55.833 32.8337V29.0003L40.4997 38.5837L25.1663 29.0003V32.8337L40.4997 42.417Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailContact);
export default __webpack_public_path__ + "static/media/mail-contact.0bfc27770b13d2269d3998e87b6ac040.svg";
export { ForwardRef as ReactComponent };